import {ApplicationModule, Component, computed, inject, ChangeDetectionStrategy} from "@angular/core"
import {FormsModule, ReactiveFormsModule} from "@angular/forms"
import {MatNativeDateModule} from "@angular/material/core"
import {HammerModule} from "@angular/platform-browser"
import {Router, RouterModule, NavigationEnd, NavigationStart} from "@angular/router"
import {BackgroundOperationListComponent} from "@common/components/background-operation-list/background-operation-list.component"
import {SideNavigationComponent} from "@common/components/navigation/side-navigation/side-navigation.component"
import {GlobalAppInjector} from "@common/helpers/app-injector/app-injector"
import {InjectorService} from "@common/services/injector/injector.service"
import {UtilsService} from "@legacy/helpers/utils"
import {navigationlessRoutes} from "@app/platform/config/navigation-config"
import {filter, map} from "rxjs"
import {toSignal} from "@angular/core/rxjs-interop"
import {environment} from "@environment"
import {OnboardingDialogComponent} from "@platform/components/dialogs/onboarding-dialog/onboarding-dialog.component"
import {StartingScreenService} from "@platform/components/dialogs/onboarding-dialog/starting-screen.service"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "colormass-app",
    templateUrl: "app.component.html",
    styleUrls: ["app.component.scss"],
    imports: [
        ApplicationModule,
        BackgroundOperationListComponent,
        FormsModule,
        HammerModule,
        MatNativeDateModule,
        SideNavigationComponent,
        ReactiveFormsModule,
        RouterModule,
        OnboardingDialogComponent,
    ],
})
export class AppComponent {
    private readonly injector = inject(InjectorService)
    private readonly router = inject(Router)
    private readonly utilsService = inject(UtilsService)
    // Instantiated here so it subscribes to login events for the whole app lifetime; the template
    // reads its $visible signal to gate the starting screen.
    protected readonly startingScreen = inject(StartingScreenService)

    protected readonly appBackgroundColor = environment.style.application.background

    // Track the current URL from both NavigationStart and NavigationEnd to avoid flicker during transitions
    private readonly $currentUrl = toSignal(
        this.router.events.pipe(
            filter((event): event is NavigationStart | NavigationEnd => event instanceof NavigationStart || event instanceof NavigationEnd),
            map((event) => event.url),
        ),
    )

    readonly $shouldHideNavigation = computed(() => {
        const url = this.$currentUrl() ?? this.router.url

        return navigationlessRoutes.some((route) => url.startsWith(route))
    })

    constructor() {
        GlobalAppInjector.injector = this.injector.injector
        this.utilsService.printAppVersion()
    }
}
